export const FIELD_TYPES = {
    TEXT_INPUT: 'TEXT_INPUT',
    TEXT_AREA: 'TEXT_AREA',
    EMAIL: 'EMAIL',
    PHONE_NUMBER: 'PHONE_NUMBER',
    URL: 'URL',
    CHECKBOX: 'CHECKBOX',
    CONSENT: 'CONSENT',
}
